import { TranslateService } from '@ngx-translate/core';

export const getCcTableLabels = (translate: TranslateService) => ({
  preItemsPerPage: translate.instant('COMMON.DISPLAY'),
  postItemsPerPage: translate.instant('COMMON.PERPAGE'),
});
